import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubmarketCreateTab from './SubmarketCreateTab';
import CreateButton from '../buttons/CreateButton';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';

function CreateSubmarketRow() {
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-submarket-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('submarkets.create-submarket')}</CreateButton>
            {isCreateVisible && <SubmarketCreateTab hideHandler={() => setCreateVisible(false)} />}
        </div>
    );
}

export default withPrivileges([Privileges.SUBMARKET_EDIT])(CreateSubmarketRow);
